exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-carbon-clap .nav-tabs .nav-item[data-v-784b4e27] {\n  width: 130px;\n  text-align: center;\n}\n.carbon-text[data-v-784b4e27] {\n  font-size: 16px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.b-tabs-forecast[data-v-784b4e27] {\n  padding-top: 0;\n}\n.b-tabs-final-report[data-v-784b4e27] {\n  padding-top: 0;\n}\n", ""]);

// exports
